import { Object3D } from "three";
/**
 * An extension over Object3D that adds functionality for preparing the object before rendering.
 *
 * onBeforeRender is not suitable for our purposes as it is only called on actually drawable objects like Mesh and it is
 * called in a phase where modifying the children array will not alter the set of objects that will be rendered. As such
 * we need our own callback.
 */
export class PreparingObject extends Object3D {
    /**
     * This function will be called exactly once per frame, before the call to WebGLRenderer.render which drives
     * rendering this object.
     *
     * The intended use of this callback is to allow objects to modify their Object3D.children array directly prior to
     * rendering.
     *
     * @param renderer The renderer the object will be rendered with
     * @param camera The camera the object is being rendered from
     * @param frameData FrameData object
     */
    // tslint:disable-next-line:no-empty
    prepare(renderer, camera, frameData) { }
}
